
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/serviceCenter/[serviceCenterId]/[serviceCenterSlug]",
      function () {
        return require("private-next-pages/serviceCenter/[serviceCenterId]/[serviceCenterSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/serviceCenter/[serviceCenterId]/[serviceCenterSlug]"])
      });
    }
  